module.exports = __webpack_public_path__ + "img/logo-2024.c8d51291.svg";